module.exports = require("./zh-Hans-MO.d.ts");